import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import './../../shared/rxjs-operators';
import { LogService, ApiService, CacheService, AppContext, Port } from './../../shared';

@Injectable()
export class PortsSearchService {
  ports: Observable<any>;
  public autoOn = false;
  public loaderOn = false;
  public noResult = false;

  constructor(private logger: LogService, private api: ApiService, private cache: CacheService, public app: AppContext) {
    this.logger.log('ports-search.service', 'constructor', this.app);
  }

  startSearch() {
    this.autoOn = true;
    this.loaderOn = true;
    this.noResult = false;
  }

  getPorts(term: string): Observable<any> {
    this.logger.log('ports-search.service', 'getPorts', term);
    this.startSearch();
    // let cache = this.cache.get('ports' + term);
    let promise = this.api.getApiClient().then(client => this.callGetPorts(client, term));
    let server = Observable.fromPromise(promise);
    this.ports = server;
    // this.ports = Observable.concat(cache, server);
    // this.cache.updateCache('ports' + term, this.ports);

    return this.ports;
  }

  callGetPorts(apigClient: any, term: string): Promise<any> {
    this.logger.log('ports-search.service', 'callGetPorts', term);
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {};
      let additionalParams = {
        headers: {
          'Content-Type': 'application/json'
        },
        queryParams: {
          search: term
        }
      };
      try {
        apigClient.portsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('ports-search.service', 'resolve', result);
            let formatted = this.endSearch(result.data);
            resolve(formatted);
          }).catch((err) => {
            this.autoOn = false;
            this.api.handleError(err);
          });
      } catch (ex) {
        this.logger.log('ports-search.service', 'catch', ex);
        return reject(ex);
      }
    });
  }

  endSearch(data: any): any {
    this.loaderOn = false;

    try {
      let formatted = new Array<Port>();

      for (let current = 0; current < data.items.length; current++) {
        formatted.push(new Port(data.items[current]));
      }

      return formatted;
    } catch (ex) {
      this.noResult = true;
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/ports-search/ports-search.service.ts